document.addEventListener('DOMContentLoaded', () => {
  // 📦 Global state
  window.bundle_discount = null;
  window.selectedQTY = [];
  window.free_upsell = false;

  // 🧠 Cache DOM elements
  const bundleQtyButtons = document.querySelectorAll('.bundle_quantity_list li');
  const bundleSlots = document.querySelector('.empty_bundle_list ul');
  const upsellSlots = document.querySelector('.upsell_empty_list ul');
  const priceDOM = document.querySelector('.bundle_body .bundle_pack_selection .price_dom');
  const variantPicker = document.querySelector('.right_block variant-picker');
  const upsellVariantPickers = document.querySelectorAll('.upsell_product_list variant-picker');
  const bundleBuilder = document.querySelector('[data-product_bundle_block]');
  const upsellList = document.querySelector('.upsell_product_list');
  const baseQty = parseInt(document.querySelector('.bundle_quantity_list li[data-baseqty="true"]').dataset.bundleQty, 10);

  // 🔧 Utility Helpers
  const parsePrice = str => parseFloat(str.replace(/[^0-9.]/g, '')) || 0;
  const formatPrice = num => `$${num.toFixed(2)}`;
  const isVisible = el => el && el.offsetParent !== null;
  const toggleDisplay = (el, show) => { if(el) el.style.display = show ? '' : 'none'; };

  function bundlePackReset() {
    const bundle_pack_variant_picker = document.querySelector(".bundle_body .bundle_pack_selection variant-picker");
    if (bundle_pack_variant_picker) {
      const option1 = bundle_pack_variant_picker.querySelector(`[data-option-label="color"] label`);
      const option2 = bundle_pack_variant_picker.querySelector(`[data-option-label="weight"] label:nth-child(3)`);
      const scentSelect = bundle_pack_variant_picker.querySelector(`[data-option-label="scent"] select`);

      // option1?.click();
      option2?.click();
      // if (scentSelect) {
      //   scentSelect.selectedIndex = 0;
      //   scentSelect.dispatchEvent(new Event('change', { bubbles: true }));
      // }
    }
  }
  bundlePackReset()

  // Add To Cart Function
  function addToCartVanilla(itemsArray, callback) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ 
        items: itemsArray
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // console.log("✅ Data added successfully - selling_plan:", data);
        if (typeof callback === "function") {
          callback();
        }
      })
      .catch((error) => {
        console.error("❌ Error adding data to cart:", error);
      });
  }

  // 📦 QTY-Based Step & Upsell Management
  function qtyStepManage(qty) {
    window.enable_vessel_for_step_1
    // 1. 🕯️ Toggle snuffer upsell visibility
    const snufferProduct = document.querySelector('.upsell_empty_list .snuffer_product');
    if (snufferProduct) {
      snufferProduct.classList.toggle('disabled', qty !== 7);
    }

    // 2. 🪜 Toggle visibility of step 2 (vessel selection)
    const step2Indicator = document.querySelector('.progress_bar_dom .item_2');  
    if (step2Indicator && baseQty && !window.enable_vessel_for_step_1) {
      step2Indicator.classList.toggle('hidden', qty === baseQty);
    }

    upsellVariantPickers.forEach((picker) => {
      updateUpsellPriceDisplay(picker); // Initial update
    });
  }

  // 🧩 Modal open logic (working)
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-build_a_pack]');
    if (!btn) return;
    e.preventDefault();
    const modal = document.querySelector('[data-product_bundle_block]');
    if (!modal) return;
    toggleDisplay(modal, true);
    document.body.style.overflow = 'hidden';
  });

  // 🔁 Modal close
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-bundlemodalclosebtn]')) return;
    const modal = document.querySelector('[data-product_bundle_block]');
    toggleDisplay(modal, false);
    document.body.style.overflow = '';
    ['1','2','3','4'].forEach(n => toggleDisplay(document.querySelector(`[data-bundlestep="${n}"]`), n === '1'));
    document.querySelectorAll('.bundle_footer button').forEach(n => toggleDisplay(n, false));
    toggleDisplay(document.querySelector('.progress_bar_dom'), false);
    ['1', '2', '3'].forEach(n => {
      const item = document.querySelector(`.progress_bar_dom .item_${n}`);
      if (item) item.classList.toggle('active', n === '1');
    });
    toggleDisplay(document.querySelector('.bundle_footer button[data-gotopreviousbundlebtn]'), true);

    const li = document.querySelector('.upsell_empty_list li');
    ['varid','varPrice'].forEach(k => delete li.dataset[k]);
    li.classList.replace('is_active','is_empty');
    li.querySelector('img.select_upsell_img').src = '';
    li.querySelector('.price_data').innerHTML = '';
  });

  // 🔙 Handle "Previous" step/back navigation
  document.addEventListener('click', function (e) {
    const s1 = document.querySelector('[data-bundlestep="1"]');
    const s2 = document.querySelector('[data-bundlestep="2"]');
    const s3 = document.querySelector('[data-bundlestep="3"]');
    const s4 = document.querySelector('[data-bundlestep="4"]');
    const modal = document.querySelector('[data-product_bundle_block]');
    const reviewBtn = document.querySelector('[data-reviewbundlebtn]');
    const atcBtn = document.querySelector('[data-atcbundlebtn]');
    const addBtns = document.querySelector('[data-addbundlebtn]');
    const nextBtns = document.querySelector('[data-next]');
    const progress = document.querySelector('.progress_bar_dom');
    const first_qty_selected = window.selectedQTY === baseQty & !window.enable_vessel_for_step_1;

    const prevBtn = e.target.closest('[data-gotopreviousbundlebtn]');
    if (prevBtn) {
      // 4 ===> 2
      // 4 ===> 3
      if (s4 && s4.offsetParent !== null) {
        reviewBtn && toggleDisplay(reviewBtn, true);
        atcBtn && toggleDisplay(atcBtn, false);
        if (first_qty_selected) {
          // 4 ===> 2
          ['1','2','3','4'].forEach(n => toggleDisplay(document.querySelector(`[data-bundlestep="${n}"]`), n === '2'));
        } else {
          // 4 ===> 3
          ['1','2','3','4'].forEach(n => toggleDisplay(document.querySelector(`[data-bundlestep="${n}"]`), n === '3'));
        }
        document.querySelector('.progress_bar_dom .item:nth-child(3)').classList.remove('active');
      }
      // 3 ===> 2
      else if (s3 && s3.offsetParent !== null) {
        ['1','2','3','4'].forEach(n => toggleDisplay(document.querySelector(`[data-bundlestep="${n}"]`), n === '2'));
        reviewBtn && (reviewBtn.style.display = 'none');
        atcBtn && (atcBtn.style.display = 'none');
        nextBtns && (nextBtns.style.display = '');
        document.querySelector('.progress_bar_dom .item:nth-child(2)').classList.remove('active');
      }
      // 2 ===> 1
      else if (s2 && s2.offsetParent !== null) {
        ['1','2','3','4'].forEach(n => toggleDisplay(document.querySelector(`[data-bundlestep="${n}"]`), n === '1'));
        nextBtns && (nextBtns.style.display = 'none');
        reviewBtn && (reviewBtn.style.display = 'none');
        addBtns && (addBtns.style.display = 'none');
        progress && (progress.style.display = 'none');
        document.querySelectorAll('.progress_bar_dom .item').forEach(el => el.classList.remove('active'));
      }
      // 1 ===> Close modal
      else if (s1 && s1.offsetParent !== null) {
        modal && (modal.style.display = 'none');
        document.body.style.overflow = '';
      }
    }

    const progressBar_item = e.target.closest('.progress_bar_data .item');
    if (progressBar_item) {
      const item = e.target;
      const isActive = item.classList.contains("active");
      let clickIndex = null;
      if (isActive) {
        clickIndex = item.getAttribute("data-index");
        console.log("clickIndex === ", clickIndex);
        if (clickIndex == 2) {
          const bundle_fill_lenght = document.querySelectorAll(".empty_bundle_list ul .is_empty");
          console.log("bundle_fill_lenght.length === ", bundle_fill_lenght.length);
          if (bundle_fill_lenght.length === 0) {
            ['1','2','3','4'].forEach(n => toggleDisplay(document.querySelector(`[data-bundlestep="${n}"]`), n === '2'));
            if (first_qty_selected) {
              reviewBtn && toggleDisplay(reviewBtn, true);
              nextBtns && toggleDisplay(nextBtns, false);
            } else {
              nextBtns && toggleDisplay(nextBtns, true);
              reviewBtn && toggleDisplay(reviewBtn, false);
            }
            addBtns && toggleDisplay(addBtns, false);
            atcBtn && toggleDisplay(atcBtn, false);
          }
        }
        else if (clickIndex == 3) {
          ['1','2','3','4'].forEach(n => toggleDisplay(document.querySelector(`[data-bundlestep="${n}"]`), n === '3'));
          reviewBtn && toggleDisplay(reviewBtn, true);
          addBtns && toggleDisplay(addBtns, false);
          nextBtns && toggleDisplay(nextBtns, false);
          atcBtn && toggleDisplay(atcBtn, false);
        }
        else if (clickIndex == 4) {
          ['1','2','3','4'].forEach(n => toggleDisplay(document.querySelector(`[data-bundlestep="${n}"]`), n === '4'));
          atcBtn && toggleDisplay(atcBtn, true);
          addBtns && toggleDisplay(addBtns, false);
          nextBtns && toggleDisplay(nextBtns, false);
          reviewBtn && toggleDisplay(reviewBtn, false);
        }
      }
    }
  });

  // 🏷 Inject variant-specific pricing
  const injectSizePrices = () => {
    const priceBySize = {};
    document.querySelectorAll('#variant_data li').forEach(li => {
      const size = li.dataset.option2, price = li.dataset.price;
      if (!priceBySize[size]) priceBySize[size] = price;
    });
    document.querySelectorAll('.variant-option[data-option-label="weight"] label').forEach(label => {
      const input = label.querySelector('input[type=radio]');
      const span = label.querySelector('.variant-option__button-label__text');
      if (priceBySize[input.value] && !span.textContent.includes(priceBySize[input.value])) {
        input.dataset.varPrice = priceBySize[input.value];
      }
    });
  };
  injectSizePrices();

  // 💲 Calculate and display current price
  const updatePriceDisplay = () => {
    const checked = document.querySelector('[data-option-label="weight"] input:checked');
    const raw = checked?.dataset.varPrice || '$0';
    const base = parsePrice(raw); // Convert string price to number
    const discount = parseFloat(window.subscriptionDiscount) || 0;

    const final = base * (1 - discount / 100);
    const saved = base - final;
    const savedPercent = base > 0 ? Math.round((saved / base) * 100) : 0;

    priceDOM.innerHTML = `
      <p>Price</p>
      <del>${raw}</del>
      <b>${formatPrice(final)}</b>
      <span>(Save ${savedPercent}%)</span>
    `;
  };

  // 🎲 Create empty bundle slots
  const cloneSlots = (qty, discount) => {
    const template = bundleSlots.querySelector('li');
    const closeSVG = template.querySelector('.bundle_clear').innerHTML;
    const emptySVG = template.querySelector('.bundle_empty').innerHTML;
    const defImg = template.querySelector('img').dataset.defaultSrc;

    bundleSlots.innerHTML = '';
    Array.from({ length: qty }).forEach((_, index) => {
      const li = document.createElement('li');
      index == 0 ? li.className = 'is_empty highlight_empty' : li.className = 'is_empty';
      li.innerHTML = `
        <span class="bundle_clear">${closeSVG}</span>
        <span class="bundle_empty">${emptySVG}</span>
        <img class="select_bundle_img" src="" data-default-src="${defImg}" alt="" />
      `;
      bundleSlots.appendChild(li);
    });
    window.subscriptionDiscount = discount;
  };

  // 🧩 Event: Bundle quantity click
  bundleQtyButtons.forEach(btn => btn.addEventListener('click', () => {
    const qty = parseInt(btn.dataset.bundleQty, 10);
    const disc = parseInt(btn.dataset.bundleDiscount, 10);
    window.subscriptionDiscount = disc;
    if (!qty) return;
    window.selectedQTY = qty;
    qtyStepManage(qty);
    updatePriceDisplay();

    // 🧱 Rebuild the bundle slots
    cloneSlots(qty, disc);

    // 🧭 Switch UI steps
    toggleDisplay(document.querySelector('[data-bundlestep="1"]'), false);
    toggleDisplay(document.querySelector('[data-bundlestep="2"]'), true);
    toggleDisplay(document.querySelector('.progress_bar_dom'), true);
    document.querySelectorAll('[data-addbundlebtn]').forEach(el => toggleDisplay(el, true));

    document.querySelector('.progress_bar_dom .item:nth-child(1)').classList.add('active');

    // Upsell Clear
    const upsell_clear = document.querySelector(".upsell_clear");
    if (upsell_clear) {
      upsell_clear.click();
    }

  }));

  function highlightFirstEmptyLi() {
    // Remove previous highlight
    document.querySelectorAll(".empty_bundle_list ul .highlight_empty").forEach(el => {
      el.classList.remove("highlight_empty");
    });

    // Find new first .is_empty
    const firstEmptyLi = document.querySelector(".bundle_body .bundle_pack_selection .empty_bundle_list ul > li.is_empty");
    if (firstEmptyLi) {
      firstEmptyLi.classList.add("highlight_empty");
    }
  }

  // 🔁 Event: Add variant to bundle slot
  document.querySelectorAll('[data-addbundlebtn]').forEach(btn => 
    btn.addEventListener('click', () => {
    console.log("CLICK Add Bundle BTN");
    
    const dataScript = document.querySelector('.right_block variant-picker script[data-variant][type="application/json"]');
    if (!dataScript) return;
    
    const v = JSON.parse(dataScript.textContent);
    // console.log("V data", v, v.inventory_quantity);

    // ✅ Variant inventory quantity
    const maxQty = v.inventory_quantity ?? 0; 

    // ✅ Count how many times this variant is already added
    const currentCount = [...bundleSlots.querySelectorAll('li.is_active')].filter(slot => slot.dataset.varid == v.id).length;
    console.log(`Variant ${v.id} already in slots: ${currentCount}, max allowed: ${maxQty}`);

    // ✅ Check stock vs already added
    if (v.available && currentCount >= maxQty) {
      let variantDom = document.querySelector(".bundle_body .bundle_pack_selection .variant-picker");
      let errorDom = document.querySelector(".bundle_body .bundle_pack_selection .variant_error");
      let variantErrorHTML = `<div class="variant_error">Sorry, no more items left in stock.</div>`;
      if (variantDom && !errorDom) {
        variantDom.insertAdjacentHTML("afterend", variantErrorHTML);
      }
      return; // stop here
    }

    // ✅ Add to next empty slot if available
    const slot = bundleSlots.querySelector('li.is_empty');
    if (slot && v.available) {
      document.querySelector(".bundle_body .bundle_pack_selection .variant_error")?.remove();

      slot.dataset.varid = v.id;
      slot.dataset.option1 = v.option1;
      slot.dataset.option2 = v.option2;
      slot.dataset.option3 = v.option3;
      slot.dataset.varPrice = document.querySelector('[data-option-label="weight"] input:checked').dataset.varPrice;
      slot.querySelector('.select_bundle_img').src = v.featured_media?.preview_image?.src 
        ? `${v.featured_media?.preview_image?.src}&width=200` 
        : slot.querySelector('img').dataset.defaultSrc;

      slot.classList.replace('is_empty', 'is_active');
    } else {
      // console.log("v.available = ", v.available);
      let variantDom = document.querySelector(".bundle_body .bundle_pack_selection .variant-picker");
      let errorDom = document.querySelector(".bundle_body .bundle_pack_selection .variant_error");
      let variantErrorHTML = `<div class="variant_error">Sorry, this item is not available, please choose a different option.</div>`;
      if (variantDom && !errorDom) {
        variantDom.insertAdjacentHTML("afterend", variantErrorHTML);
      }
    }
    
    // Toggle buttons
    if (!bundleSlots.querySelector('li.is_empty')) {

      const data_add_btn = document.querySelector(".bundle_footer [data-next]");
      const data_reviewbundlebtn = document.querySelector(".bundle_footer [data-reviewbundlebtn]");

      document.querySelectorAll('[data-addbundlebtn]').forEach(el => toggleDisplay(el, false));
      if (window.selectedQTY === baseQty & !window.enable_vessel_for_step_1) {
        toggleDisplay(document.querySelector('[data-reviewbundlebtn]'), true);
        data_reviewbundlebtn?.click();
      } else {
        toggleDisplay(document.querySelector('[data-next]'), true);
        data_add_btn?.click();
      }
    }
    highlightFirstEmptyLi()
    bundlePackReset()
    
  }));

  // ❌ Clear a bundle slot
  bundleSlots.addEventListener('click', (ev) => {
    if (ev.target.closest('.bundle_clear')) {
      const li = ev.target.closest('li');
      ['varid','option1','option2','option3','varPrice'].forEach(k => delete li.dataset[k]);
      li.classList.replace('is_active','is_empty');
      li.querySelector('img').src = '';
      document.querySelectorAll('[data-addbundlebtn]').forEach(el => toggleDisplay(el, true));
      toggleDisplay(document.querySelector('[data-next]'), false);
      toggleDisplay(document.querySelector('[data-reviewbundlebtn]'), false);
      document.querySelectorAll('.progress_bar_dom .item:nth-child(2), .progress_bar_dom .item:nth-child(3)').forEach(el => el.classList.remove('active'));
    }
  });

  // 🔁 Event: Add variant to Upsell slot
  document.querySelectorAll('.upsellAddToCartBtn').forEach(btn => btn.addEventListener('click', (e) => {
    const prentDom = e.target.closest(".upsell_item");
    const vid = e.target.dataset.vid;
    const vImg = prentDom.querySelector(".item_images img:not(.hidden)").src;
    const priceData = prentDom.querySelector(".price_dom").innerHTML;
    const pTitle = prentDom.querySelector(".item_title").innerText;
    const slot = upsellSlots.querySelector('li');
    slot.dataset.varid = vid;
    slot.dataset.ptitle = pTitle;
    slot.querySelector('.select_upsell_img').src = vImg;
    slot.querySelector('.price_data').innerHTML = priceData;
    slot.classList.replace('is_empty', 'is_active');
    slot.classList.remove('highlight_empty');

    const empty_upsellSlots_lenght = document.querySelectorAll(".upsell_empty_list ul .is_empty");
    const btn_reviewbundle = document.querySelector(".bundle_footer [data-reviewbundlebtn]");
    // console.log("empty_upsellSlots_lenght ====== ", empty_upsellSlots_lenght.length)
    empty_upsellSlots_lenght.length === 0 && btn_reviewbundle?.click();

  }));

  // ❌ Clear a Upsell slot
  upsellSlots.addEventListener('click', (ev) => {
    if (ev.target.closest('.upsell_clear')) {
      const li = ev.target.closest('li');
      ['varid','varPrice'].forEach(k => delete li.dataset[k]);
      li.classList.replace('is_active','is_empty');
      li.classList.add('highlight_empty');
      li.querySelector('img.select_upsell_img').src = '';
      li.querySelector('.price_data').innerHTML = '';
    }
  });
  
  // ⏭ Next Step --- [data-next]
  document.addEventListener('click', ev => {
    if (!ev.target.closest('[data-next]')) return;
    ['2','3'].forEach(n => toggleDisplay(document.querySelector(`[data-bundlestep="${n}"]`), n === '3'));
    toggleDisplay(document.querySelector('[data-next]'), false);
    toggleDisplay(document.querySelector('[data-reviewbundlebtn]'), true);
    document.querySelector('.progress_bar_dom .item:nth-child(2)').classList.add('active');
  });

  function updateBundleTotals() {
    const prices = document.querySelectorAll(".bundle_review_dom .product_price");
    let subtotal = 0;
    let finalTotal = 0;
    let totalSavings = 0;
  
    prices.forEach((priceBlock) => {
      if (!priceBlock) return;
  
      const originalPriceEl = priceBlock.querySelector("del");
      const finalPriceEl = priceBlock.querySelector("b");
      const freeText = priceBlock.querySelector('[data-text="free"]');
  
      let original = 0;
      let final = 0;
  
      // 🧮 Corrected original price: Use <del> if available, else fallback to <b>
      if (originalPriceEl && originalPriceEl.textContent) {
        original = parseFloat(originalPriceEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      } else if (finalPriceEl && finalPriceEl.textContent) {
        original = parseFloat(finalPriceEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      }
  
      // 🧮 Final price logic
      if (freeText) {
        final = 0;
      } else if (finalPriceEl && finalPriceEl.textContent) {
        final = parseFloat(finalPriceEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      }
  
      subtotal += original;
      finalTotal += final;
      totalSavings += (original - final);
    });
  
    const format = val => `$${val.toFixed(2)}`;
  
    document.querySelector(".totle_price_data .subtotal span:last-child").textContent = format(subtotal);
    document.querySelector(".totle_price_data .final span:last-child").textContent = format(finalTotal);
    document.querySelector(".atc_bundle_btn .final").textContent = format(finalTotal);
    document.querySelector(".totle_price_data .save span:last-child").textContent = format(totalSavings);
    document.querySelector(".final_save_dom .save_price").textContent = format(totalSavings);
  }

  // 👀 Final bundle review --- [data-reviewbundlebtn]
  document.addEventListener('click', ev => {
    if (!ev.target.closest('[data-reviewbundlebtn]')) return;
    toggleDisplay(document.querySelector('[data-reviewbundlebtn]'), false);
    toggleDisplay(document.querySelector('[data-atcbundlebtn]'), true);
    ['2','3','4'].forEach(n => toggleDisplay(document.querySelector(`[data-bundlestep="${n}"]`), n === '4'));
    const review = document.querySelector('.bundle_review_dom .review_dom');
    // Default List
    review.innerHTML = `<li class="table_header"><div>Item</div><div>Details</div><div>Price</div></li>`;
    // Bundle List
    bundleSlots.querySelectorAll('li.is_active').forEach(li => {
      const p = parsePrice(li.dataset.varPrice);
      const disc = window.subscriptionDiscount || 0;
      const final = p * (1 - disc / 100);
      review.innerHTML += `
        <li>
          <div class="product_item"><img class="item_img" src="${li.querySelector('img').src}" alt="${li.dataset.option1}"></div>
          <div class="product_details"><span>${li.dataset.option1}</span><span>${li.dataset.option2}</span><span>${li.dataset.option3}</span></div>
          <div class="product_price">
            <del>$${p.toFixed(2)}</del>
            <b>$${final.toFixed(2)}</b>
            <span>(Save $${(p-final).toFixed(2)})</span>
            <div data-bundle-edit class="bundle_edit_button"><img src="https://cdn.shopify.com/s/files/1/0735/8031/4864/files/edit.png?v=1754568522" alt="Edit Button" /></div>
          </div>
        </li>`;
    });
    // Upsell List
    upsellSlots.querySelectorAll('li.is_active:not(.disabled)').forEach(li => {
      review.innerHTML += `
        <li>
          <div class="product_item"><img class="item_img" src="${li.querySelector('img.select_upsell_img').src}" alt="${li.dataset.option1}"></div>
          <div class="product_details"><span>${li.dataset.ptitle}</span></div>
          <div class="product_price">${li.querySelector('.price_data').innerHTML}</div>
        </li>`;
    });
    
    updateBundleTotals();
    
    document.querySelector('.progress_bar_dom .item:nth-child(3)').classList.add('active');
  });

  document.addEventListener('click', ev => {
    if (!ev.target.closest('[data-atcbundlebtn]')) return;
    const current_time = document.querySelector(".product_bundle_block .current_time").innerText;
    const productHandle = document.querySelector('[data-bundlestep="4"]').dataset.productHandle;

    const items = [];
    fetch(`/products/${productHandle}?section_id=variant-json`)
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshVariants = JSON.parse(doc.querySelector('#ProductVariantsJSON').textContent);

      // ✅ Step 1: Bundle variant counting + out-of-stock cleanup
      const counts = {};
      const removedSlots = [];
      const runningCounts = {}; 

      [...bundleSlots.querySelectorAll('li.is_active')].forEach((li, index) => {
        const varId = parseInt(li.dataset.varid, 10);
        const variant = freshVariants.find(item => item.id === varId);
        const requestedQty = 1; // tamara slot rules mujab
        items.push({
          id: varId,
          quantity: requestedQty,
          properties: {
            _bundle_product: varId,
            _bundle_time: current_time,
            ...(index === 1 ? { _main_product: true } : { _child_product: true })
          }
        });

        if (!counts[varId]) {
          counts[varId] = {
            id: varId,
            quantity: 0,
            properties: {
              ...(index === 1 ? { _main_product: true } : { _child_product: true }),
              _bundle_product: varId,
              _bundle_time: current_time
            }
          };
        }
        counts[varId].quantity += 1;

        // ✅ Stock check part
        if (variant) {
          if (!runningCounts[varId]) runningCounts[varId] = 0;
          runningCounts[varId] += 1;

          // Check if this occurrence exceeds inventory
          if (runningCounts[varId] > variant.inventory_quantity) {
            removedSlots.push({
              index: index,
              varId: varId,
              title: variant.title,
              selected: counts[varId].quantity,
              available: variant.inventory_quantity
            });
          }
        }
      });

      // console.log("Counts after cleanup:", counts);
      // console.log("Removed slots:", removedSlots);
      
      // ✅ Step 2: Inventory check (collect multiple OOS items)
      const outOfStockItems = [];
      for (const varId in counts) {
        const matchedVariant = freshVariants.find(v => v.id === parseInt(varId, 10));
        if (matchedVariant && matchedVariant.inventory_quantity < counts[varId].quantity) {
          // outOfStockItems.push(`${matchedVariant.title} (only ${matchedVariant.inventory_quantity} left)`);
          outOfStockItems.push({
            title: matchedVariant.title,
            selected: counts[varId].quantity,
            available: matchedVariant.inventory_quantity
          });
          // delete counts[varId];
        }
      }

      // console.log("Out of stock items:", outOfStockItems);
      
      // ✅ Step 3: Show popup if any out of stock
      if (outOfStockItems.length > 0 && removedSlots.length > 0) {
        showOutOfStockPopup(outOfStockItems, removedSlots);
        return; // 🚫 stop, don't add to cart
      }

      // ✅ Step 4: Convert counts object → items array
      // const items = Object.values(counts);

      // ✅ Step 5: Upsell slots (no check)
      [...upsellSlots.querySelectorAll('li.is_active:not(.disabled)')].forEach(li => {
        const varId = parseInt(li.dataset.varid, 10);
        if (!varId) return;

        if (window.free_upsell == true) {
          items.push({
            id: varId,
            quantity: 1,
            properties: {
              _free_upsell: window.free_upsell,
              _bundle_upsell: "true",
              _bundle_time: current_time
            }
          });
        } else {
          items.push({ id: varId, quantity: 1 });
        }
      });

      console.log("✅ Final items:", items);

      // ✅ Step 6: Add to cart
      addToCartVanilla(items, () => {
        window.location.href = '/cart';
      });
    });
  });


  // 🔔 Custom popup function
  function showOutOfStockPopup(items, removedSlots) {
    let popup = document.querySelector('#oosPopup');
    if (!popup) {
      popup = document.createElement('div');
      popup.id = 'oosPopup';
      popup.innerHTML = `
        <div class="oos-overlay"></div>
        <div class="popup-content">
          <h3>Some items are out of stock</h3>
          <ul class="oos-list"></ul>
          <button class="oos-close bundle_btn_style_1">OK</button>
        </div>
      `;
      document.body.appendChild(popup);

      // close button
      popup.querySelector('.oos-close').addEventListener('click', () => {
        popup.classList.remove('active');
        removedSlots.forEach(slot => {
          const li = bundleSlots.querySelectorAll('li.is_active')[slot.index];
          if (li) {
            const clearBtn = li.querySelector('.bundle_clear');
            if (clearBtn) clearBtn.click();
          }
        });
        ['1','2','3','4'].forEach(n => toggleDisplay(document.querySelector(`[data-bundlestep="${n}"]`), n === '2'));
        const atcBtn = document.querySelector('[data-atcbundlebtn]');
        atcBtn && toggleDisplay(atcBtn, false);
      });
    }

    // Update list
    const list = popup.querySelector('.oos-list');
    // list.innerHTML = items.map(i => `<li>${i}</li>`).join("");
    list.innerHTML = items.map(i => 
      `<li>${i.title} <span>Selected: ${i.selected}, Available: ${i.available}</span></li>`
    ).join('');

    // Show popup
    popup.classList.add('active');
  }

  const updateUpsellPriceDisplay = (data) => {
    const prentDom = data.parentNode.parentNode;
    const main_parentDom = data.closest('.upsell_item');
    const priceElement = main_parentDom.querySelector('.price_dom');
    const atcBtn = main_parentDom.querySelector('.upsellAddToCartBtn');
    const imgDom = main_parentDom.querySelectorAll('.item_images img');
    const dataPriceDom = data.querySelector(".variant_p_data");
    if (!dataPriceDom) return;
  
    const dataId = data.querySelector(".variant_p_data").getAttribute("data-variant-id");
    const dataVarAvailable = data.querySelector(".variant_p_data").getAttribute("data-var-available");
    atcBtn.dataset.vid = dataId;
    dataVarAvailable == "true" ? atcBtn.classList.remove('disabled') : atcBtn.classList.add('disabled');
  
    // Show only the image matching the selected variant ID
    imgDom.forEach(img => {
      if (img.dataset.vid === dataId) {
        img.classList.remove('hidden');
      } else {
        img.classList.add('hidden');
      }
    });
  
    // Update price display
    const toggleDisplay = (el, show) => { if(el) el.style.display = show ? '' : 'none'; };
    const upsell_list = document.querySelectorAll(".upsell_product_list .upsell_item");
    const first_qty_selected = window.selectedQTY === baseQty & window.enable_vessel_for_step_1;
    priceElement.innerHTML = dataPriceDom.innerHTML;
    
    // Show paid or free upsell based on baseQty logic
    if (baseQty === undefined || first_qty_selected) {
      // Show the Paid upsell
      upsell_list.forEach(item => {
        toggleDisplay(item, item.classList.contains('paid_upsell'));
      });
      window.free_upsell = false;
    } else {
      // Show the Free upsell
      upsell_list.forEach(item => {
        toggleDisplay(item, item.classList.contains('free_upsell'));
      });
      window.free_upsell = true;
    }
  };
  
  // 🔄 Observe variant changes for price update & media update
  if (variantPicker) {
    const jsonNode = variantPicker.querySelector('script[type="application/json"]');
    if (!jsonNode) return;
  
    let lastJson = jsonNode.textContent;
  
    new MutationObserver(() => {
      const newJson = jsonNode.textContent;
      if (newJson === lastJson) return;
  
      lastJson = newJson;
      // console.log("✅ Variant JSON changed");
  
      injectSizePrices();
      updatePriceDisplay();
  
      // 👉 Media update logic
      try {
        const variantData = JSON.parse(newJson);
        const activeMediaID = variantData?.featured_media?.id;
        if (!activeMediaID) return;
  
        const mediaEls = document.querySelectorAll('.product_media_list .media');
        mediaEls.forEach(el => {
          const elID = el.getAttribute('data-media-id');
          el.style.display = (elID === String(activeMediaID)) ? 'block' : 'none';
        });
  
      } catch (err) {
        console.error("❌ Failed to parse variantData for media update:", err);
      }
    }).observe(jsonNode, {
      characterData: true,
      subtree: true,
      childList: true,
    });
  }

  // 🔄 Observe Upsell variant
  upsellVariantPickers.forEach((picker) => {
    updateUpsellPriceDisplay(picker);
    new MutationObserver(() => {
     updateUpsellPriceDisplay(picker) 
    }).observe(picker, {childList: true, subtree: true, characterData: true});
  });
  
  // Upsell Iten Info Trigger
  document.querySelectorAll('.item_info_trigger').forEach((trigger, index) => {
    const modal = document.querySelectorAll('.info_modal_dom')[index];
    const closeBtn = modal?.querySelector('.info_close');
  
    if (!modal) return;
  
    // ✅ Open modal
    trigger.addEventListener('click', () => {
      modal.classList.toggle('active');
    });
  
    // ❌ Close modal by close button
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        modal.classList.remove('active');
      });
    }
  
    // ❌ Close modal by clicking outside modal box
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.classList.remove('active');
      }
    });
  });

  // 🔁 Edit Bundle In Last Step
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-bundle-edit]')) return;
    const secound_step = document.querySelector(".progress_bar_data .item.item_1");
    secound_step?.click();
  });

  // Handle scent popup open/close
  document.addEventListener("click", (e) => {
    const openTrigger = e.target.closest(".scent_guide_trigger");
    const closeTrigger = e.target.closest(".popup_close");

    // Open popup
    if (openTrigger) {
      document.body.classList.add("scent_popup_active");
      return;
    }

    // Close on "X" button
    if (closeTrigger) {
      document.body.classList.remove("scent_popup_active");
      return;
    }

    // Close when clicking background overlay only
    const overlay = document.querySelector(".scent_popup_outerdom");
    if (overlay && e.target === overlay) {
      document.body.classList.remove("scent_popup_active");
      return;
    }
  });
  const targetNode = document.querySelector('.bundle_body .bundle_pack_selection');
  if (targetNode) {
    const observer = new MutationObserver(() => {
      document.querySelectorAll('variant-picker input[type="radio"]').forEach(input => {
        if (!input.hasAttribute('data-listener-added')) {
          input.setAttribute('data-listener-added', 'true');

          input.addEventListener('change', (e) => {
            const mediaId = e.target.getAttribute('data-variant-media-id');
            console.log("Selected media id:", mediaId);

            const parentUpsell = e.target.closest('.upsell_item');
            if (parentUpsell) {
              const variantId = e.target.getAttribute('data-variant-id');
              const upsellImages = parentUpsell.querySelectorAll('.upsell_item .item_images img');
              upsellImages.forEach(img => {
                if (img.getAttribute('data-media-id')) {
                  if (img.getAttribute('data-media-id') === mediaId) {
                    img.classList.remove('hidden');
                  } else {
                    img.classList.add('hidden');
                  }
                }
              });
              // ----- Update variant_p_data -----
              const variantDataEl = parentUpsell.querySelector('.variant_p_data');
              if (variantDataEl && variantId) {
                variantDataEl.setAttribute('data-variant-id', variantId);
              }

              // ----- Update Add to Cart Button -----
              const atcBtn = parentUpsell.querySelector('.upsellAddToCartBtn');
              if (atcBtn && variantId) {
                atcBtn.setAttribute('data-vid', variantId);
              }
            } else {
              document.querySelectorAll('.media-image .media').forEach(img => {
                if (img.getAttribute('data-media-id') === mediaId) {
                  img.style.display = 'block';
                } else {
                  img.style.display = 'none'; 
                }
              });
            }
            updatePriceDisplay();
          });
        }
      });
    });
    observer.observe(targetNode, { childList: true, subtree: true });
  }
});

setInterval(function () {
  var c_seconds = new Date();
  document.querySelector(".product_bundle_block .current_time").innerText = c_seconds.getTime();
}, 1000);

